// extracted by mini-css-extract-plugin
export default {"card":"Yt3UwD6w","image":"VZ6stkxe","content":"pLd6prpm","title":"zaIW3Vbg"};